import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ApiDocsPageComponent } from '../component/page/api-docs-page/api-docs-page.component';
import { AuthGuardService } from '../service/auth-guard.service';

const routes: Routes = [
  { path: 'api/docs', component: ApiDocsPageComponent, canActivate: [AuthGuardService] },
  { path: 'api/docs/revision-notices/:pageTitle', component: ApiDocsPageComponent, canActivate: [AuthGuardService] },
  { path: 'api/docs/:apiName', component: ApiDocsPageComponent, canActivate: [AuthGuardService] },
  { path: 'api/docs/:apiName/:tabName', component: ApiDocsPageComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppApiDocsRoutingModule {}
